export default __webpack_public_path__ + "static/Cannon_Ball-60eded02e9ea660f24e0b37caa35bb50.png";